import "slick-carousel";
import $ from 'jquery';

import '../styles/sites41-45/style.scss';
import "./cookie";
import {unsubscribeLogic} from "./unsubscribe";
import {paymentLogic} from "./paymentPagesLogic";
import {scrollLogic} from "./scrollLogic";
import {loginPageLogic} from "./login";
import {contactFormLogic} from "./contactForm";
import "./tw-elements/faq";
import "./tw-elements/header";
import "./elements/header";
import {useCountersSync} from "./counters";
import {pricingSwitchersLogic} from "./elements/pricingSwitchersLogic";
import customSliderButtons from "./elements/customSliderButtons";

document.addEventListener("DOMContentLoaded", () => {

  useCountersSync(".counters-container");
  pricingSwitchersLogic();
  scrollLogic(0);
  unsubscribeLogic();
  paymentLogic();
  loginPageLogic();
  contactFormLogic();
  customSliderButtons();
  document.querySelectorAll(".slick-slider").forEach(sliderElement => {
    const slider = $(sliderElement);
    const slidesToShow = sliderElement.dataset.slides ? +sliderElement.dataset.slides : 3;
    const slidesToShowXl = sliderElement.dataset.slidesXl ? +sliderElement.dataset.slidesXl : slidesToShow;
    slider.slick({
      dots: !!slider[0].dataset.dots,
      fade: !!slider[0].dataset.fade,
      autoplay: !!slider[0].dataset.autoplay,
      vertical: !!slider[0].dataset.vertical,
      infinite: true,
      speed: 300,
      slidesToShow,
      slidesToScroll: 1,
      // centerMode: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: slidesToShowXl,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: slidesToShowXl - 1 <= 1 ? 1 : slidesToShowXl - 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        },
        // {
        //   breakpoint: 600,
        //   settings: {
        //     slidesToShow: 2,
        //     slidesToScroll: 2
        //   }
        // },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     slidesToScroll: 1
        //   }
        // }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    })
  });

  console.log('Common script is loaded');
});
